// src/components/blog/BlogCard.tsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../types/blogTypes';
import { formatPostDate } from '../../utils/blogFormat';
import BlogThumbnail from './BlogThumbnail';

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  padding: 12px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 36px rgba(34, 50, 70, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover,
  &:focus-visible {
    transform: translateY(-3px);
    box-shadow: 0 24px 44px rgba(34, 50, 70, 0.2);
  }

`;

const Body = styled.div`
  display: grid;
  gap: 8px;
  padding: 0 10px 12px;
`;

const Meta = styled.p`
  margin: 0;
  font-size: 14px;
  color: #3f4c5a;

  strong {
    color: #1f2b3a;
    font-weight: 600;
  }
`;

const Excerpt = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: #2f3d4c;
`;

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => (
  <Card to={`/blog/${post.slug}/`} aria-label={post.title}>
    <BlogThumbnail post={post} />
    <Body>
      <Meta>
        By <strong>{post.author}</strong> · {formatPostDate(post.publishedAt)}
      </Meta>
      <Excerpt>{post.description}</Excerpt>
    </Body>
  </Card>
);

export default React.memo(BlogCard);
